<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="SEI供应商">
        <span slot="label">{{$t("tab.tab_sei_vend")}}</span>
        <VendTableSEI></VendTableSEI>
      </el-tab-pane>
      <el-tab-pane label="供应商">
        <span slot="label">{{$t("tab.tab_vend")}}</span>
        <VendTable></VendTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VendTableSEI from "./VendTableSEI";
import VendTable from "./VendTable";

export default {
  name: "VendTableMain",
  components: {
    VendTableSEI,
    VendTable
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
